import { render, staticRenderFns } from "./area-key.component.vue?vue&type=template&id=3b874db0&scoped=true&"
import script from "./area-key.component.vue?vue&type=script&lang=ts&"
export * from "./area-key.component.vue?vue&type=script&lang=ts&"
import style0 from "./area-key.component.vue?vue&type=style&index=0&id=3b874db0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b874db0",
  null
  
)

export default component.exports